<a [href]="nqsRouterLink" target="_blank" class="nqs-link">
    <cc-icon
        [size]="'medium'"
        [icon]="'open'"
        [color]="'var(--link-color)'"
        [hoverColor]="'var(--link-hover-color)'"
    >
    </cc-icon>
    Named Query Service
</a>
<a [href]="cfbRouterLink" target="_blank" class="cfb-link">
    <cc-icon
        [size]="'medium'"
        [icon]="'open'"
        [color]="'var(--link-color)'"
        [hoverColor]="'var(--link-hover-color)'"
    >
    </cc-icon>
    Custom Field Builder
</a>
